// import components
import Button from '@sdb/ui/atoms/Button';
import { Typography } from '@mui/material';
import { StyledAiMatchFooterBox } from '../AIMatch.styles';

// import types
import { AIMatchFooterProps } from './AIMatchFooter.types';
import { useTranslation } from 'react-i18next';
import { Icon } from '@sdb/planning-ui';

const AIMatchFooter = ({ formState }: AIMatchFooterProps) => {
  const { t } = useTranslation('common', { keyPrefix: 'aiMatchSettings' });

  return (
    <StyledAiMatchFooterBox>
      {formState.isDirty && (
        <>
          <Icon type="triangle-exclamation" color="warning" />
          <Typography>{t('unsavedChanges')}</Typography>
        </>
      )}

      <Button
        type="submit"
        variant="contained"
        color="dark"
        disabled={
          !formState.isDirty || Object.keys(formState.errors).length > 0
        }
      >
        {t('save')}
      </Button>
    </StyledAiMatchFooterBox>
  );
};

export default AIMatchFooter;
